(function (ws) {
    'use strict';
    ws.views.orderlistingTable = ws.views.simpleTable.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'order_activity',
        GTM_EVENT_ACTION: 'search_order',

        /**
         * Events override
         */
        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'change #tbl-simple-orderby': 'searchFilter',
            'keypress .tbl-simple-searchInput': 'searchFunction',
            'change input#tbl-simple-start-date': 'validateDate',
            'change input#tbl-simple-end-date': 'validateDate',
            'keydown input#tbl-simple-end-date': 'validateDate',
            'keydown input#tbl-simple-start-date': 'validateDate',
            'focusout input#tbl-simple-end-date': 'validateDate',
            'focusout input#tbl-simple-start-date': 'validateDate',
            'change input#tbl-simple-price-lower': 'validatePrice',
            'change input#tbl-simple-price-upper': 'validatePrice',
            'keydown input#tbl-simple-price-lower': 'validatePrice',
            'keydown input#tbl-simple-price-upper': 'validatePrice',
            'change select#tbl-simple-page-size': 'searchFilterStatus',
            'change .headerLevelClass': 'searchFilterStatus',
            'click .tbl-magnifying': 'triggerSearch',
            'click #clearFilterBtn': 'toggleDisable',
            'click .order-export-checkbox-selectAll': 'toggleAllCheckboxes',
            'click .export-multiOrder': 'downloadMultipleOrder',
            'click .order-export-checkbox': 'enableDownlodButton'
        }),

        /**
         * Initialize override
         */
        initialize: function () {
            this.$table = this.$('#order-table');
            this.paginateUrl = globals.path.api.westcon.orderlistingTablePaginateUrl;
            this.searchUrl = globals.path.api.westcon.orderlistingTableSearchUrl;
            this.rowTemplate = this.$('#orderlisting-table-row');
            this.overrideFilterRequest = true;
            this.$orderbByCriteria = this.$('#tbl-simple-orderby');
            this.$searchInput = this.$('.tbl-simple-searchInput');
            this.$selectAllCheckbox = this.$('.order-export-checkbox-selectAll');

            this.controlColumn = 0;

            this.showVRFColumns = this.$('#showVRFColumns').val();
            this.enableToDeliveryStatusOLP = this.$('#enableToDeliveryStatusOLP').val();
            this.enableOrdersExport = this.$('#enableOrdersExport').val();
            this.multiViewEnabled = this.$('#multiViewEnabled').val();
            this.is3plOrder = this.$('#is3plOrder').val();
            this.exportMultiOrder = this.$('.export-multiOrder');

            ws.views.simpleTable.prototype.initialize.call(this);

            //Making the select dropdowns without scroll and without search textbox
            $('.tbl-simple-filters select').select2({
                minimumResultsForSearch: Infinity,
                dropdownAutoWidth: true,
                dropdownCssClass: 'comp-order-table'
            });

            if (this.multiViewEnabled == 'true') {
                this.$selectAllCheckbox.attr('checked', false);
                this.$('.order-export-checkbox').prop('checked', false);
            }

            this.enableDownlodButton();

            this.searchCategory = 'orders';
            this.serialNoLength = this.$('.serialNoLength');
            this.searchType = this.$('#searchType');
            this.placeholderMsg = this.$('.placeholderMsg');
            setTimeout(function () {
                var ignoreClickOnMeElement = document.getElementById('headerOptions');
                var ignoreClickOnMe = document.getElementById('checkboxesHeader');

                $('#headerOptions').select2('destroy');
                $('.overSelect').on('click', function(event) {
                    $('.checkboxesHeader').toggle();
                    event.stopPropagation();
                });

                if (ignoreClickOnMeElement && ignoreClickOnMe) {
                    $(document).on('click', function(event) {
                        var isClickInsideElement = ignoreClickOnMeElement.contains(event.target);
                        var isClickInside = ignoreClickOnMe.contains(event.target);
                        if (!isClickInsideElement && !isClickInside) {
                            $('#checkboxesHeader').css('display', 'none');
                        }
                    });
                }
            }, 1000);
        },

        /**
         * toggling the button
         * @param {Object} e
         */
        toggleDisable: function (e) {
            if (e != undefined) {
                if (e.currentTarget.id === 'clearFilterBtn') {
                    this.exportMultiOrder.show();
                    if (this.multiViewEnabled == 'true') {
                        this.enableDownlodButton();
                    }

                }

                this.$selectAllCheckbox.attr('checked', false);
            }
        },

        /**
         * Search
         * @param {Object} e
         */
        search: function (e) {
            if (e.which === 13) {
                this.eventAgg.trigger('resetSortColumns');
                ws.views.simpleTable.prototype.search.call(this, e);
            }
        },

        /**
         * Call Search Filter API
         * Overriding from the parent view
         * @param {Object} request
         */
        searchFilterCall: function (request) {
            this.model.set(request);
            this.model.url = this.searchUrl;
            this.$table.dataTable().fnClearTable();
            this.$table.dataTable().fnDestroy();
            this.$table.DataTable().destroy();

            this.$tableSpinner.show();
            this.$emtpyTableCopy.hide();

            $.each(this.$tableHeaders, function (i, th) {
                $(th).removeClass('loaded');
            });

            // calling without arguments to hide pagination
            this.calculateShowing();
            this.calculatePagination();
            this.enableDelaySpinner();

            this.model.save().done(function (data) {
                this.$tableSpinner.hide();
                this.disabledDelaySpinner();
                this.renderRows(data.data);
                if (data.data.length >= 1) {
                    this.exportMultiOrder.show();
                    this.checkSelectAllCheckbox();
                } else {
                    this.exportMultiOrder.hide();
                }

                this.calculateShowing(data.paginationData);
                this.calculatePagination(data.paginationData);
                this.$pagination.addClass('search');
                this.$clearFilterButton.toggle(this.showClearFilterButton);
                if (this.showClearFilterButton) {
                    this.$('.message-link').hide();
                }

                this.toggleApplySearchBtn(true);
                if (this.enableOrdersExport === 'true') {
                    this.$selectAllCheckbox.attr('checked', false);
                }

            }.bind(this)).fail(function () {
                this.tableGenericError();
                this.disabledDelaySpinner();
            }.bind(this));
        },

        /**
         * Overiding the Render a table row from the parent
         * @param {Object} result
         */
        renderRows: function (result) {
            if (this.enableOrdersExport === 'true') {
                this.$selectAllCheckbox.attr('checked', false);
                this.enableDownlodButton();
            }

            var options;
            var _this = this;
            _.each(result, function (row) {
                row.showVRFColumns = _this.showVRFColumns;
                row.enableToDeliveryStatusOLP = _this.enableToDeliveryStatusOLP;
                row.enableOrdersExport = _this.enableOrdersExport;
                row.multiViewEnabled = _this.multiViewEnabled;
                row.is3plOrder = _this.is3plOrder;
                if (row.status == null) {
                    row.status = '';
                }

                options = {
                    model: row,
                    rowTemplate: _this.rowTemplate
                };
                var tableRow = new ws.views.simpleTableRows(options);
                _this.$table.append(tableRow.render().el);
            });

            this.fadeInRows();
            this.initializeDataTable();

            if (this.sortColumn) {
                this.$table.find('th[data-attr=' + this.sortColumn + ']').addClass('sorting_' + this.sortCode);
            }
        },

        /**
         *  Enable the download button and disable Download Button
         */
        enableDownlodButton: function () {
            var $checkboxes = this.$('.order-export-checkbox');
            var flag = 1;
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).is(':checked')) {
                    $('.export-multiOrder').attr('disabled', false);
                    flag = 0;
                } else {
                    $('.order-export-checkbox-selectAll').prop('checked', false);
                }
            });

            if (flag === 1) {
                $('.export-multiOrder').attr('disabled', true);
            }

            this.checkSelectAllCheckbox();
        },

        /**
         * Check select all checkbox and check/uncheck
         */
        checkSelectAllCheckbox () {
            const totalCheckboxes = this.$('.order-export-checkbox').length;
            const selectedCheckboxes = $('.order-export-checkbox:checked').length;
            if (selectedCheckboxes == 0) {
                this.$selectAllCheckbox.prop('checked', false);
            } else {
                this.$selectAllCheckbox.prop('checked', totalCheckboxes === selectedCheckboxes);
            }
        },

        /**
         * Change the state of all the checkboxes in the Order Listing table table.
         * @param {Object} ev
         */
        toggleAllCheckboxes: function (ev) {
            var $checkboxes = this.$('.order-export-checkbox');
            var $checkboxAll = this.$('.order-export-checkbox-selectAll');
            _.each($checkboxes, function(checkbox) {
                $(checkbox).prop('checked', $checkboxAll.is(':checked'));
            });

            this.enableDownlodButton();
        },

        /**
         * Downloading the multiple orders excel functionality
         */
        downloadMultipleOrder: function () {
            globals.disableApp();
            var $checkboxes = this.$('.order-export-checkbox');
            var orderNumberList = [];
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).prop('checked') === true) {
                    orderNumberList.push($(checkbox).data('attr'));
                }
            });

            const CSRFToken = $('#CSRFToken').val();
            const urlExportOrderList = globals.path.api.westcon.exportOrderList + '?CSRFToken=' + CSRFToken;
            const data = {
                orderNumberList: orderNumberList
            };

            // DOWNLOADING EXCEL FILE FROM THE BLOB.
            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                var a;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    // Trick for making downloadable link
                    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                        navigator.msSaveBlob(xhttp.response, 'MultipleOrderDownload.xls');
                    } else {
                        a = document.createElement('a');
                        a.href = window.URL.createObjectURL(xhttp.response);

                        // Give filename you wish to download
                        a.download = 'MultipleOrderDownload.xls';
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                    }

                    globals.enableApp();
                }
            };

            xhttp.open('POST', urlExportOrderList);
            xhttp.setRequestHeader('Content-Type', 'application/json');
            xhttp.responseType = 'blob';
            xhttp.send(JSON.stringify(data));
        },

        // Search Function
        searchFunction: function (e) {
            let serialNoLength = this.serialNoLength.html();
            if (e.which === 13) {
                e.preventDefault();
                if (e.target.value) {
                    if (this.$searchInput.val().length < parseInt(serialNoLength) && this.searchType.val() === 'serialNumber') {
                        this.placeholderMsg.show();
                    } else {
                        this.placeholderMsg.hide();
                        this.search(e);
                    }
                }
            }
        },

        // Validate Date
        validateDate: function (e, makeApiCall = true) {
            // if pressing enter key, prevent refresh (since some tables are forms)
            //e may not be defined if date changed happens from pikaday

            let serialNoLength = this.serialNoLength.html();
            if (e && (e.keyCode === 13 || e.which === 13)) {
                e.preventDefault();
            }

            if (this.$searchInput.val().length < parseInt(serialNoLength) && this.searchType.val() === 'serialNumber') {
                this.placeholderMsg.show();
            } else {
                this.placeholderMsg.hide();
                var beginningDate = this.$startDateInput.val();
                var endDate = this.$endDateInput.val();
                var beginDateValid = globals.validateDate(beginningDate);
                var endDateValid = globals.validateDate(endDate);

                //remove error classes
                this.$startDateInput.removeClass('error');
                this.$endDateInput.removeClass('error');
                this.$dateError.hide();
                this.$validDateError.hide();
                this.$searcherrors.hide();

                //show start date error
                if (beginDateValid === false) {
                    this.$startDateInput.addClass('error');
                    this.$dateError.show();
                }

                //show end date error
                if (endDateValid === false) {
                    this.$endDateInput.addClass('error');
                    this.$dateError.show();
                }

                //check for start date is less than end date
                var validCheck = '';
                if (endDateValid && beginDateValid) {
                    validCheck = globals.compareDates(beginningDate, endDate);
                    if (!validCheck) {
                        this.$validDateError.show();
                    }
                }

                //if no errors and either enter key pressed, or change made from pikaday, make api call
                if (beginDateValid === true && endDateValid === true && validCheck === true && ((e.keyCode === 13 || e.which === 13) || (e === 'pikaday')) && makeApiCall) {
                    var gaEventLabel = beginningDate + ',' + endDate + '_date_range';
                    this.searchFilter(e, undefined, gaEventLabel);
                }
            }
        },

        /**
         * Check price fields
         */
        validatePrice: function (e, makeApiCall = true) {
            this.$searcherrors.hide();
            var keyCode = e.keyCode || e.which;
            let serialNoLength = this.serialNoLength.html();

            //if pressing enter key, prevent refresh (since some tables are forms)
            if (keyCode === 13) {
                e.preventDefault();
            }

            if (this.$searchInput.val().length < parseInt(serialNoLength) && this.searchType.val() === 'serialNumber') {
                this.placeholderMsg.show();
            } else {
                this.placeholderMsg.hide();
                var lowerPriceLimit = this.$priceInputLower.val();
                var upperPriceLimit = this.$priceInputUpper.val();
                var error = false;

                //remove error classes from price inputs
                this.$priceerror.hide();
                this.$priceInputLower.removeClass('error');
                this.$priceInputUpper.removeClass('error');

                //make sure inputs are numbers
                if (isNaN(lowerPriceLimit)) {
                    this.$priceInputLower.addClass('error');
                    error = true;
                }

                if (isNaN(upperPriceLimit)) {
                    this.$priceInputUpper.addClass('error');
                    error = true;
                }

                //make sure lower price is less than upper price
                if (lowerPriceLimit && upperPriceLimit && (parseFloat(lowerPriceLimit) > parseFloat(upperPriceLimit))) {
                    this.$priceInputLower.addClass('error');
                    this.$priceInputUpper.addClass('error');
                    this.$priceerror.show();
                    error = true;
                }

                this.error = error;

                //only search if enter key pressed
                if (error === false && keyCode === 13 && makeApiCall) {
                    var gaEventLabel = lowerPriceLimit + ',' + upperPriceLimit + '_price_range';
                    this.searchFilter(e, undefined, gaEventLabel);
                }
            }
        },

        searchFilterStatus: function (e = undefined, page = undefined, gaEventLabel = undefined) {
            let serialNoLength = this.serialNoLength.html();
            var statusList = [];
            if (this.$searchInput.val().length < parseInt(serialNoLength) && this.searchType.val() === 'serialNumber') {
                this.placeholderMsg.show();
            } else {
                this.placeholderMsg.hide();
                this.$searcherrors.hide();
                this.$apiErrors.hide();
                $('.headerlineLevelOptions input:checkbox:checked').each(function () {
                    statusList.push($(this).attr('data-value'));
                });

                var searchProperty = this.searchType.val();
                var searchText = this.$searchInput.val();
                var statusText = this.$statusInput.val() === this.$statusInput.data('placeholder') ? '' : this.$statusInput.val();
                var sourceText = this.$sourceInput.val() === this.$sourceInput.data('placeholder') ? '' : this.$sourceInput.val();
                var amText = this.$amInput.val();
                var quoteNumber = !_.isUndefined(this.$quoteNumber) ? this.$quoteNumber.val() : '';
                var copyQuoteOption = !_.isUndefined(this.$copyQuoteOption) ? this.$copyQuoteOption.val() : '';
                var beginningDate = this.$startDateInput.val();
                var endDate = this.$endDateInput.val();
                var startDueDate = this.$startDueDateInput.val();
                var endDueDate = this.$endDueDateInput.val();
                var lowerPriceLimit = parseFloat(this.$priceInputLower.val());
                var upperPriceLimit = parseFloat(this.$priceInputUpper.val());
                var pageSize = this.$pageSizeInput.val();
                var selectedSalesOrg = !_.isUndefined(this.$salesOrgValue.val()) ? this.$salesOrgValue.val() : this.$salesOrg.val();
                this.error = false;

                //don't show clear filter button if changing page size
                this.showClearFilterButton = e && $(e.currentTarget).attr('id') !== 'tbl-simple-page-size' && !page || this.$clearFilterButton.is(':visible');

                var request = {
                    amFilter: amText,
                    searchText: searchText,
                    searchProperty: searchProperty,
                    quoteCloseFromDate: startDueDate,
                    quoteCloseToDate: endDueDate,
                    fromDate: beginningDate,
                    toDate: endDate,
                    lowPrice: lowerPriceLimit,
                    highPrice: upperPriceLimit,
                    sortCode: this.sortColumn,
                    order: this.sortCode,
                    sortType: this.sortCode,
                    salesOrg: selectedSalesOrg,
                    page: page, //failing on search rfq by price
                    pageSize: pageSize,
                    statusList: statusList, //statusText,
                    source: sourceText,
                    type: sourceText,
                    quoteNum: quoteNumber,
                    copyQuoteOption: copyQuoteOption,
                    paginationData: '', //makes sure this is not an object, otherwise BE error
                    data: ''
                };

                // update request object if filters for table are not the usual search criteria, input field, date, price range ones
                if (this.overrideFilterRequest === true) {
                    request = this.customFilterRequest(request);
                }

                /**
                 * Checking the store site and handling event tracking for Google Analytics
                 * GTM_EVENT_CATEGORY and GTM_EVENT_ACTION inherited from accountquotetable view
                 *
                 */
                if (isEcomSite) {
                    if (e && $(e.currentTarget).attr('id') === 'tbl-simple-select') {
                        this.gtmEventTracking(this.GTM_EVENT_CATEGORY, 'filter_quote', 'status_' + $(e.currentTarget).val());
                    } else if (e && $(e.currentTarget).attr('class') === 'tbl-simple-searchInput') {
                        this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, this.gtmFilterOptions[searchProperty]);
                    } else if (gaEventLabel) {
                        this.gtmEventTracking(this.GTM_EVENT_CATEGORY, 'filter_quote', gaEventLabel);
                    }
                }

                if (location.href.indexOf('store') > -1) {

                    dataLayerAA.search = {};
                    dataLayerAA.search.type = this.searchCategory;
                    dataLayerAA.search.field = searchProperty;
                    dataLayerAA.search.query = searchText;

                    if ($('#pageName').val() === 'orderlistingpage')
                        dataLayerAA.search.status = statusText;

                    _satellite.track('event:search');
                }

                this.searchFilterCall(request);
                this.handleClearSearch(request);
            }
        },
        /**
         * Toggle ClearSearch button
         * @param {*} request
         */
        handleClearSearch: function (request) {
            var searchCount = 0;

            _.each(this.$tableSimpleFilters.find('input[type="text"], select, select.tbl-criteria, input:checked'), function ($field) {
                if ($($field).val() && request.searchProperty !== $($field).val() && $($field).val() !== request.pageSize) {
                    searchCount++;
                }
            });

            if ($('.tbl-simple-filters').find('input:checked').length > 0) {
                searchCount++;
            }

            if (searchCount === 0) {
                this.showClearFilterButton = false;
            }
        },

        /**
         * Trigger Search
         */
        triggerSearch: function () {
            this.eventAgg.trigger('resetSortColumns');
            const e = $.Event('keypress', {which: 13});
            this.$searchInput.trigger(e);
        },

        /**
         * Override filter request object
         * @param {Object} request
         */
        customFilterRequest: function (request) {
            return _.extend({}, request, {
                orderedBy: this.$orderbByCriteria.val()
            });
        },

        disableFutureDate: true
    });
})(westcon);
